/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_ExperimentsInputs */

const en_pricing_experiments = /** @type {(inputs: Pricing_ExperimentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing experiments`)
};

const es_pricing_experiments = /** @type {(inputs: Pricing_ExperimentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimentos de precios`)
};

/**
* | output |
* | --- |
* | "Pricing experiments" |
*
* @param {Pricing_ExperimentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_experiments = /** @type {((inputs?: Pricing_ExperimentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_ExperimentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_experiments(inputs)
	return en_pricing_experiments(inputs)
});